export default {"src":"/_next/static/media/personio-logo.4e961939.svg","height":90,"width":127};